import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import { FlexDataItem } from 'components/FlexDataView'
import Typography from '@material-ui/core/Typography'
import { DateTimeDisplay } from 'components'
import DateIcon from '@material-ui/icons/DateRange'

export class DateDisplay extends PureComponent {
  static propTypes = {
    date: PropTypes.any,
    label: PropTypes.string,
    type: PropTypes.oneOf(['Start', 'End'])
  }

  pastTense = word => `${word}ed`
  futureTense = word => `${word}s`

  get typeWithTense() {
    const {date, type} = this.props
    return moment(date) <= moment() ? this.pastTense(type) : this.futureTense(type)
  }

  render = () => {
    const {date, label} = this.props
    return (
      <FlexDataItem>
        <Typography variant='subtitle1'><DateIcon />{label}</Typography>
        <dl>
          <dt>{this.typeWithTense} on</dt>
          <dd><DateTimeDisplay value={date} singleLine/></dd>
        </dl>
      </FlexDataItem>
    )
  }

}